// ResetButton.tsx
import React from 'react';

interface ResetButtonProps {
  widget: any;
  dashboardName: string;
  handleResetToDefault: (widget: any, dashboardName: string) => void;
  isChartConfig: boolean;
}

const ResetButton: React.FC<ResetButtonProps> = ({ widget, dashboardName, handleResetToDefault, isChartConfig }) => {
  if (!dashboardName || dashboardName.toLowerCase().includes('realtime')) {
    return null;
  }
  const widgetProperty = widget?.widgetProperty;
  const isResetEnabled = (() => {
    if (widget?.widgetProperty?.dashboard === dashboardName && isChartConfig) {
      return !(widgetProperty.widgetProperties.parameterConfig[0].default as boolean);
    }
    return !widget?.widgetProperty?.isDefault;
  })();
  return (
    <button
      onClick={() => (isResetEnabled ? handleResetToDefault(widget, dashboardName) : undefined)}
      disabled={!isResetEnabled}
      className={`footer-button ${!isResetEnabled ? 'disabled' : ''}`}
    >
      Reset default filter
    </button>
  );
};

export default ResetButton;
